<template>
    <div class="uk-container">
        <div>
            <img :src="fileUrl">
        </div>
        <tags type="tag" blockTitle="活動内容タグ" v-bind:blockElements="photoData.taglist" v-bind:masterElements="tagmaster"></tags>
        <tags type="area" blockTitle="活動場所" v-bind:blockElements="photoData.arealist" v-bind:masterElements="areamaster"></tags>
        <tags type="member" blockTitle="メンバー" v-bind:blockElements="photoData.memberlist" v-bind:masterElements="membermaster"></tags>
        <div class="uk-margin">
            <button class="uk-button uk-margin-auto uk-width-1-2 save_button" @click="saveData">保存して戻る</button>
            <button class="uk-button uk-margin-auto uk-width-1-2 cancel_button" @click="cancel">キャンセル</button>
        </div>
    </div>
</template>

<script>
/* eslint-disable */
import qs from 'qs'
import tags from './components/Tags'

export default {
    name: 'app',
    components: {
        tags,
    },
    props: {
    },
    data: function () {
        return {
            photo: {},
            fileUrl: String,
            photoData: {
                id: 0,
                taglist: [],
                memberlist: [],
                arealist: [],
            },
            tagmaster: [],
            membermaster: [],
            areamaster: [],
        }
    },
    methods: {
        async saveData () {
            // マスター更新
            this.photoData.arealist.forEach(element => {
                if (!this.areamaster.includes(element)) {
                    this.saveMaster('areas', element)
                }
            })
            this.photoData.memberlist.forEach(element => {
                if (!this.membermaster.includes(element)) {
                    this.saveMaster('members', element)
                }
            })
            this.photoData.taglist.forEach(element => {
                if (!this.tagmaster.includes(element)) {
                    this.saveMaster('tags', element)
                }
            })

            // 写真データ更新
            this.photo.areas = this.photoData.arealist.join(' ')
            this.photo.members = this.photoData.memberlist.join(' ')
            this.photo.tags = this.photoData.taglist.join(' ')

            await this.$axios.post(
                this.$config.common.apiPath + '/savePhoto/',
                qs.stringify(this.photo)
            )
            .then(response => {
                // NOP
                // this.$store.dispatch('updateFullList', this.$config.common.apiPath)
                // TOPに戻る
            })
            .catch( function(error){
                // TODO
                // TOPに戻る
            })

            let url = '/'
            this.$router.push(url)
        },
        saveMaster: function (tbl, elmnt) {
            this.$axios.post(
                this.$config.common.apiPath + '/saveMaster/',
                qs.stringify({table: tbl, element: elmnt})
            )
            .then(response => {
                // NOP
            })
            .catch( function(error){
                // TODO
            })
        },
        cancel: function () {
            let url = '/'
            this.$router.push(url)
        }
    },
    mounted () {
        var id = this.$route.query.id
        this.$axios.post(
            this.$config.common.apiPath + '/getPhoto/',
            qs.stringify({'id': id})
        )
        .then(response => {
            this.photo = response.data.data
            this.fileUrl = this.$config.common.photoPath + this.photo.photo
            this.photoData.id = id

            if (this.photo.tags !== '') {
                this.photoData.taglist = this.photo.tags.split(' ')
            } else {
                this.photoData.taglist = []
            }
            if (this.photo.members !== '') {
                this.photoData.memberlist = this.photo.members.split(' ')
            } else {
                this.photoData.memberlist = []
            }
            if (this.photo.areas !== '') {
                this.photoData.arealist = this.photo.areas.split(' ')
            } else {
                this.photoData.arealist = []
            }
        })
        .catch( function(error){
            // TODO
        })

        this.$axios.get(
            this.$config.common.apiPath + '/getMaster/'
        )
        .then(response => {
            this.areamaster = response.data.data.areas
            this.membermaster = response.data.data.members
            this.tagmaster = response.data.data.tags
        })
        .catch( function(error){
            // TODO
        })
    }
}
</script>

<style scoped>
.save_button {
    background-color: #005390;
    color: #fff;
    border: 1px solid transparent;
}
.cancel_button {
    background-color: #cc3333;
    color: #fff;
    border: 1px solid transparent;
}
</style>